import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../../firebase-client";

const money = (minor, currency = "GBP") =>
  new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency,
  }).format(Number(minor || 0) / 100);

export default function MembershipPaymentStatus({ teamId, enabled }) {
  const [records, setRecords] = useState([]);
  const [error, setError] = useState("");
  useEffect(() => {
    if (!enabled || !teamId) return undefined;
    let active = true;
    httpsCallable(
      functions,
      "getMyMembershipPayment",
    )({ teamId })
      .then((result) => {
        if (active) setRecords(result.data?.records || []);
      })
      .catch((err) => {
        if (active)
          setError(
            err?.message || "Payment details are temporarily unavailable.",
          );
      });
    return () => {
      active = false;
    };
  }, [enabled, teamId]);
  if (!enabled) return null;
  if (error)
    return (
      <p className="text-muted small" role="status">
        {error}
      </p>
    );
  if (!records.length)
    return (
      <div className="membership-change-card">
        <strong>Club-managed payment</strong>
        <p className="text-muted" style={{ margin: "0.35rem 0 0" }}>
          Your club has not assigned you to a payment round.
        </p>
      </div>
    );
  return (
    <div aria-label="My membership payment status">
      {records.map((record) => (
        <div className="membership-change-card" key={record.key}>
          <strong>
            {record.round?.name || "Membership payment"} — {record.status}
          </strong>
          <p style={{ margin: "0.35rem 0 0" }}>
            Balance:{" "}
            {money(
              Math.max(0, record.expectedAmountMinor - record.paidAmountMinor),
              record.round?.currency,
            )}
            {record.round?.dueDate
              ? ` · Due ${new Date(record.round.dueDate).toLocaleDateString("en-GB")}`
              : ""}
          </p>
          {record.round?.instructions && (
            <p
              className="text-muted"
              style={{ margin: "0.35rem 0 0", whiteSpace: "pre-wrap" }}
            >
              {record.round.instructions}
            </p>
          )}
        </div>
      ))}
    </div>
  );
}

MembershipPaymentStatus.propTypes = {
  teamId: PropTypes.string.isRequired,
  enabled: PropTypes.bool,
};
